import React from 'react';
import { TemplatePreview } from '..';

import './templatepreviewbox.css';

const TemplatePreviewBox=({
  templates=[],
  title,
  onClick,
  status,
  type // type of design (CSS)
})=>{

  let templatesHtml;
  if(status==='loading') {
    templatesHtml=<h3>Loading templates...</h3>;
  } else if(!templates.length) {
    templatesHtml=<h3 className="notice1">You don't have templates yet.</h3>;
  } else {
    templatesHtml=templates.map((elem,index)=><TemplatePreview type={type} onClick={onClick} key={'dt_'+index} template={elem} />);
  }

  let titleHtml = title ? <h3 className="font-color2">{title}</h3> : false;

  return (
    <div className="template-preview-box">
      {titleHtml}
      <div>
        {templatesHtml}
      </div>
    </div>
  )
}

export default TemplatePreviewBox;